import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SaleOrderService {


  constructor(private http: HttpClient) { }
  url = environment.serverAPI5 + '/' + 'api/salesOrder';

  url1 = environment.serverAPI1 + "/api";

  url2 = environment.serverAPI5 + '/' + 'api';

  searchSalesOrder(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getSalesOrder(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllSalesOrderDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getSalesOrderById(salesOrderId: number): Observable<Object> {
    return this.http.get(`${this.url}/${salesOrderId}`);
  }

  getSalesOrderNo(saleOrderNo: any): Observable<Object> {
    return this.http.get(`${this.url}/no?saleOrderNo=${saleOrderNo}`);
  }
  createSalesOrder(SalesOrder: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, SalesOrder);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }
  downloadSalesOrderReport(Page: number, size: number, sort, selectionSales): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionSales, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }
  downloadSalesOrderTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  deleteBySalesOrderId(salesOrderId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${salesOrderId}`);
  }

}
